module.exports = {"TXTWCL_Claim_your_bonus":{"id":"TXTWCL_Claim_your_bonus","defaultMessage":"Claim your bonus","track":"Claim your bonus"}}